import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { Position } from '@turf/turf';
import { slopePointIcon } from '../../../../../../configs/map-icon.config';

interface DirectionalPointMarkersProps {
    directionalPoints: Position[];
    markerColor: string;
}
const DirectionalPointMarkers: React.FC<DirectionalPointMarkersProps> = ({ directionalPoints, markerColor }) => {
    return (
        <>
            {directionalPoints.map((point: any) => {
                if (point.point[0] !== 0 || point.point[1] !== 0 || point.elevation != -Infinity) {
                    return (
                        <Marker position={point.point} icon={slopePointIcon(markerColor)}>
                            <Popup closeButton={false} autoClose={false}>
                                <div>
                                    ارتفاع:{' '}
                                    <span style={{ fontWeight: 'bold' }}>
                                        {point.elevation < 0 ? `${Math.abs(point.elevation)}-` : point.elevation}
                                    </span>{' '}
                                    متر از سطح دریا{' '}
                                </div>
                            </Popup>
                        </Marker>
                    );
                } else return <></>;
            })}
        </>
    );
};

export default DirectionalPointMarkers;
